import { defineChain } from 'viem';
import { AVAILABLE_EVM_CHAINS, WEB3_ADDRESS } from './chains';
import { getEvmChainPreset } from './evm-registry';
/** wagmi/RainbowKit chains derived from DEPLOYED_CONTRACTS + WEB3_ADDRESS. */
export function getWagmiChains() {
    return AVAILABLE_EVM_CHAINS.map((name) => {
        const chain = name;
        const preset = getEvmChainPreset(chain);
        const info = WEB3_ADDRESS[chain];
        return defineChain({
            ...preset,
            rpcUrls: {
                ...preset.rpcUrls,
                default: { http: info.rpc },
            },
        });
    });
}
